import { RouteObject } from "react-router-dom"
import AuthGuard from "../../../shared/auth/component/auth"
import BillingPage from "../page/billing.page"
export const BillingRoute: RouteObject = {
  path: "/billing",
  element: (
    <AuthGuard role={["super_admin", "owner"]} permission={["manage-payments", "view-payments"]}>
      <BillingPage />
    </AuthGuard>
  ),
}
